"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _modalContext = _interopRequireDefault(require("../../modal-context"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

// Context
// Helpers
var ModalFooterButton = function ModalFooterButton(props) {
  var _useContext = (0, _react.useContext)(_modalContext["default"]),
      onClose = _useContext.onClose,
      dataElementPrefix = _useContext.dataElementPrefix;

  return _react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, (0, _omit["default"])(props, 'children'), {
    dataElementLocation: _taggingHelper.DataElementLocations.POP_UP,
    dataElementLabel: "".concat(dataElementPrefix, "-modal-footer-button--").concat(props.tag),
    dataElementId: "".concat(dataElementPrefix, "-modal-footer-button--").concat(props.tag),
    onClick: function onClick(e) {
      if (props.onClick) {
        props.onClick(e);
      }

      onClose();
    }
  }), props.children);
};

ModalFooterButton.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  tag: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func
};
var _default = ModalFooterButton;
exports["default"] = _default;